import * as $ from 'jquery';
import 'bootstrap';
// import 'selectiize';
import { memberPortal } from "../member-portal";
import { bookingFormCommon } from '../c005-bookingform-common';
import { adobeDataLayerWrapper } from "../adobeDataLayerMethod";
require('parsley');

export class onlineServicesExtend{
    private proceedPayment:any = $('#payment-proceed');
    $scope:any = $('#online-services--extend-points');
    private $loginError :Array<string> =[];
    private formEl:any = $('#online-services--reactivate-points');
    private memberBase:any = new memberPortal() ;$error:Array<any>;
    private enrichExtendData : any = null;
    private bookingformcommon = new bookingFormCommon();
    private statecodes: any = [];

    /**
     * Initialize all points inputs with focus and filled effects
     * @return {any} [description]
     */
    initTextInputs():any {
		let _self = this;
		let inputElArr:any = _self.formEl.find('input[type="text"]');
		_self.memberBase.initFormTextInputs(inputElArr);
	}
    enrichExtendPointsCheck(): any {
        let defer = $.Deferred();
        let populateurl:string = '';
		if (window.location.hostname === 'localhost' && window.location.port == '5000') {
			populateurl = '/dummy-data/extendPoint.json';
		}
		else {
			populateurl = '/bin/services/new/getTierExteReactivePtnsPurchase';
		}
		let _self = this;
        var data={
            'purchaseType':"EXTEND_AWARDS"
        }
        _self.bookingformcommon.preloader();
		$.ajax({
			type: 'GET',
			url:populateurl,
            data:data,
			success: function(msg:any) {
                _self.bookingformcommon.preloaderClose();
				if(typeof msg==='string'){
				msg = JSON.parse(msg);
				}else{
					msg=msg;
                }
                if(msg.errorCode === "OK") {
                _self.enrichExtendData = msg;
                let ExtendPoints =$('.onlineServiceExtendpoints  .eligible-points-value.table-items-border-right');
                let ValidityElitePointsEarned = $('#validity-in-months-desktop , #validity-in-months-mobile');
                let ratePerElitePoints =$('#rate-per-extend-points-desktop, #rate-per-extend-points-mobile');
                let ExtendPointsval =$('#online-services-extend-desktop');
                ExtendPoints.html(msg.maximumAmount);
                ValidityElitePointsEarned.html(msg.expiryPeriod);
                ratePerElitePoints.html(msg.monetaryAmount);

                ExtendPointsval.attr('max',(msg.maximumAmount));
                ExtendPointsval.attr('min','1');
                let ratePerElitePointsval =$('#online-services--extend-amountval');
                ratePerElitePointsval.html('@'+'&nbsp'+'MYR'+msg.monetaryAmount+'&nbsp'+'/  Points');
            
                    $('.payment-error').addClass('hideclass');
                    $('.payment-error').removeClass('showclass');
                    $('#online-services-extend-desktop').removeAttr('disabled');
                    $('#terms-checkbox').removeAttr('disabled');
                } else {
                    $('.payment-error').addClass('showclass');
                    $('.payment-error').removeClass('hideclass');
                    //$('.payment-error').html('You currently do not have any expiring points to extend.');
                    $('#online-services-extend-desktop').attr('disabled', 'disabled');
                    $('#terms-checkbox').attr('disabled', 'disabled');
                }
            }, error: function(error: any) {
                _self.bookingformcommon.preloaderClose();
                defer.reject(error);
            }
            });
	}
    ValidationForm(): any {
        $('#terms-checkbox,#online-services-extend-desktop,#online-services-extend-mobile').on("click keyup",function(){ 
            let check = $('#terms-checkbox');     
            // if($(".disabled-mob").css('display') === 'none')
            // {
            //     var extendval=$("#online-services-extend-mobile").val();
            // }
            // else
            // {
                var extendval=$("#online-services-extend-desktop").val();
            // }
            if(check.is(':checked') && extendval>0)
            {
                    $('#payment-proceed').css('opacity','1');
                    $('#payment-proceed').css('background-color','#005aaa');
                    $('#payment-proceed').css('pointer-events','auto');
                }else{  
                    $('#payment-proceed').css('opacity','0.5');
                    $('#payment-proceed').css('background-color','#808080');
                    $('#payment-proceed').css('pointer-events','none');
                }
            });
        $('#online-services-extend-desktop').on("click keyup",function(){ 
            let ExtendPoints =$('.onlineServiceExtendpoints  .eligible-points-value.table-items-border-right');
            var extendValue = $(this).val();
            var eliteValuemax = ExtendPoints.html();
            var currnt=$('#current-elite-points').html();
            if(parseInt(extendValue)>=(parseInt(eliteValuemax)))
            {
                $('#online-services--extend-amount').text(eliteValuemax);
                $('#online-services-extend-desktop').val(eliteValuemax);
                var currencyCode= $('#rate-per-extend-points-desktop').html();
                let textValue =eliteValuemax * currencyCode;
                var totalValue = bigDecimal.round(textValue, 2, bigDecimal.RoundingModes.DOWN);
                $('#my-order-points-extend-value, #my-order-points-extend-total').text(totalValue);
            }
            else
            {       
                $('#online-services--extend-amount').text(extendValue)
                var currencyCode= $('#rate-per-extend-points-desktop').html();
                let textValue = $(this).val() * currencyCode;
                var totalValue = bigDecimal.round(textValue, 2, bigDecimal.RoundingModes.DOWN);
                $('#my-order-points-extend-value, #my-order-points-extend-total').text(totalValue);
            }             

        });
  }
    //Invoice pop-up functionality
    invoiceIssuancePopup(): any {
        $('input[name="invoice-flag"]').change(function () {
            let selectedInvocieFlag = $(this).val();
            // Show or hide specific fields based on the selected value
            if (selectedInvocieFlag === 'invoice-true') {
                $(".invoice-popup").show();
                //$('.selection-invoice-issuance-container').show();
                $('input[value="my"]').prop('checked', true);
                $('input[value="single"]').prop('checked', true);
                // $('#invoice-issuarce-form').show();
                $('#passport-group-extend').hide();
                $('#SSM-group-extend').hide();
                $(".invoice-popup").removeClass("hide");
            } else if (selectedInvocieFlag === 'invoice-false') {
                // $('#invoice-issuarce-form').hide();
                $('.selection-invoice-issuance-container').hide();
                $(".invoice-popup").addClass("hide");
            }
        });
        $('input[name="citizenship"]').change(function () {
            let selectedCitizen = $(this).val();
            // Show or hide specific fields based on the selected value
            if (selectedCitizen === 'my') {
                $('#invoice-issuarce-form-extend').show();
                $('#passport-group-extend').hide();
                $('#NRIC-group-extend').show();
                $("#SST-group-extend").hide();
                $('#SSM-group-extend').hide();
                $('.error').remove();
            } else if (selectedCitizen === 'nonmalaysian') {
                $('#invoice-issuarce-form-extend').show();
                $('#passport-group-extend').show();
                $('#NRIC-group-extend').hide();
                $("#SST-group-extend").hide();
                $('#SSM-group-extend').hide();
                $('.error').remove();


            }
        });
        $('input[name="Payer-Type"]').change(function () {
            let selectedPayer = $(this).val();
            // Show or hide specific fields based on the selected value
            if (selectedPayer === 'single') {
                $('#invoice-issuarce-form-extend').show();
                $('#passport-group-extend').hide();
                $('#NRIC-group-extend').show();
                $("#SST-group-extend").hide();
                $('#SSM-group-extend').hide();
                $('.error').remove();
                $('.selection-nationality').show();
            } else if (selectedPayer === 'group') {
                $('#invoice-issuarce-form-extend').show();
                $('#passport-group-extend').hide();
                $('#NRIC-group-extend').hide();
                $('#SSM-group-extend').show();
                $("#SST-group-extend").show();
                $('.error').remove();
                $('.selection-nationality').hide();
            }
        });
    }
    invoicePopupCheckbox(): void {
        let _self = this;
        var invoicePopup = $.Deferred();
        let authenticationUrl: string = '';
        let countryselect: any;
        $('.error').remove();
        $("#invoice-issuance-checkbox-extend").click(function () {
            if (window.location.hostname === 'localhost' && window.location.port == "5000") {
                authenticationUrl = '/dummy-data/getMemberShipData.json';
            }
            else {
                authenticationUrl = '/bin/services/new/getMembershipLCPAPI';
            }
            var data = {
                'action': 'fetch'
            };
            $.ajax({
                type: 'POST',
                url: authenticationUrl,
                data: data,
                success: function (data: any) {
                    //_self.bookingformcommon.preloaderClose();
                    let json: any = null;
                    if (typeof data === 'string') {
                        json = JSON.parse(data);
                    } else {
                        json = data;
                    }
                    if (data) {
                        $("#invoice_issuarce_name_extend").val(json.firstName);
                        $("#invoice_issuarce_number_extend").val(json.mobileNumber);
                        $("#invoice_issuarce_email_extend").val(json.email);
                        $("#invoice_issuarce_address_extend").val(json.homeAddress1);
                        $("#invoice_issuarce_passport_extend").val(json.passportNumber);
                        $("#invoice_issuarce_NRIC_extend").val(json.nricnumber);
                        // $("#issuanceCountry").append('<option style="color:black;" value="' + "23" + '">'  +   json.homeCountry + '</option>')
                        $("#issuanceCountry_extend").val(json.homeCountry);
                        // const countryVal = 
                        //const coutrysLength = $('select#issuanceCountry option').length;
                        //const totalCountrys = $("#issuanceCountry");
                        // for(i=0; i>)
                        // for (var i = 0; i < coutrysLength; i++) {
                        //     if ($('select#issuanceCountry option')[i].value == countryVal) {
                        //         $(_self).attr("selected","selected");
                        //     }
                        // }
                        $("#issuanceState_extend").val(json.homeState);
                        $("#invoice_issuarce_city_extend").val(json.homeCity);
                        $("#invoice_issuarce_postCode_extend").val(json.homePostCode);

                        countryselect = $('#issuanceCountry_extend');
                        const countrySelectedVal = $("#issuanceCountry_extend").val();
                        let listItems: any[] = [];
                        if (countrySelectedVal) {
                            let availableStates = $.grep(_self.statecodes.CountriesList, function (country: any, ind: any) {
                                return country.CountryCode == countryselect.val()

                            })
                            let sel = $('.issuance-state-drop-extend select');
                            $('.error').remove();
                            if (availableStates[0]) {
                                availableStates = availableStates[0].StatesList
                                listItems = []
                                for (var i = 0; i < availableStates.length; i++) {
                                    listItems[i] += "<option value='" + availableStates[i].StateCode + "'>" + availableStates[i].StateName + "</option>";
                                }
                            } else {
                                listItems[0] += ('<option value="NULL">--</option>');
                                $('.issuance-state-drop-extend select').after('<span class="error">No states availble for selected country</span>');
                            }
                            sel.empty();
                            sel.append(listItems);
                        }
                    }
                }, error: function (error: any) {
                    invoicePopup.reject(error)
                }
            });
        });
    };
    handleCountryStates(): any {
        let _self = this;
        let countryselect: any;
        var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

        countryselect = $('#issuanceCountry_extend');

        let listItems: any[] = [];
        countryselect.on("change", function () {
            let availableStates = $.grep(_self.statecodes.CountriesList, function (country: any, ind: any) {
                return country.CountryCode == countryselect.val()

            })
            let sel = $('.issuance-state-drop-extend select');
            $('.error').remove();
            if (availableStates[0]) {
                availableStates = availableStates[0].StatesList
                listItems = []
                for (var i = 0; i < availableStates.length; i++) {
                    listItems[i] += "<option value='" + availableStates[i].StateCode + "'>" + availableStates[i].StateName + "</option>";
                }
            } else {
                listItems[0] += ('<option value="NULL">--</option>');
                $('.issuance-state-drop-extend select').after('<span class="error">No states availble for selected country</span>');
            }
            sel.empty();
            sel.append(listItems);
        })
    }
    //Country and States Drop-Down Data Getting
    selectCountryData(): void {
        let _self = this;
        var countryInput = $('.issuance-country-drop-extend select');

        var getCountryOptions = $.Deferred();
        let countrycodeurl: string = '';
        if (window.location.hostname === 'localhost' && window.location.port == "5000") {
            countrycodeurl = '/dummy-data/countrycode.json';
        }
        else {
            countrycodeurl = '/content/dam/mas/json/countrycode.json';
        }
        //countrycodeurl = '/content/dam/mas/json/countrycode.json';
        $.get(countrycodeurl)
            .done((data: any) => {
                var listItems = "<option value=''> </option>";
                if (window.location.hostname === 'localhost' && window.location.port == "5000") {
                    if (typeof data === 'string') {
                        data = JSON.parse(data);
                    }
                }
                for (var i = 0; i < data.Countries.length; i++) {
                    listItems += "<option value='" + data.Countries[i].Code + "'>" + data.Countries[i].Name + "</option>";
                }
                getCountryOptions.resolve(listItems);
                $(countryInput).append(listItems);
            })
            .fail((error: any) => {
                getCountryOptions.reject(error);
            });

        // new country and state code 
        var stateCodeInput = $('.issuance-state-drop-extend select');
        let newcountrycodeurl: string = '';
        if (window.location.hostname === 'localhost' && window.location.port == "5000") {
            newcountrycodeurl = '/dummy-data/updateState.json';
        }
        else {
            newcountrycodeurl = '/content/dam/mas/json/statecodes.json'
        }
        var getnewCountryOptions = $.Deferred();
        $.get(newcountrycodeurl)
            .done((data: any) => {
                var listItems = "<option value=''> </option>";
                if (window.location.hostname === 'localhost' && window.location.port == "5000") {
                    if (typeof data === 'string') {
                        data = JSON.parse(data);
                    }
                }
                //localStorage.setItem("lcp-search", JSON.stringify(data));		
                for (var i = 0; i < data.CountriesList.length; i++) {
                    listItems += "<option value='" + data.CountriesList[i].CountryCode + "'>" + data.CountriesList[i].CountryName + "</option>";
                }
                getnewCountryOptions.resolve(listItems);
                //$(stateCodeInput).append(listItems);
            })
            .fail((error: any) => {
                getnewCountryOptions.reject(error);
            });
        var stateCodeInput = $('.issuance-state-drop-extend select');
        // var stateCodeInputmob = $('#update-profile--personal-statesmob');		
        var getStateCodeOptions = $.Deferred();
        let stateCodeUrl: string = '';
        $.get(newcountrycodeurl)
            .done((data: any) => {
                var listItems = "<option value=''> </option>";
                if (window.location.hostname === 'localhost') {
                    if (typeof data === 'string') {
                        data = JSON.parse(data);
                    }
                }
                _self.statecodes = data
                _self.handleCountryStates();
                //_self.handleCountryStatesmob();
                for (var i = 0; i < data.CountriesList.length; i++) {
                    for (var j = 0; j < data.CountriesList[i].StatesList.length; j++) {
                        if (data.CountriesList[i].StatesList[j].StateCode != 'NULL') {
                            listItems += "<option value='" + data.CountriesList[i].StatesList[j].StateCode + "'>" + data.CountriesList[i].StatesList[j].StateName + "</option>";
                        }
                    }
                }
                getStateCodeOptions.resolve(listItems);
                $(stateCodeInput).append(listItems);

            })
            .fail((error: any) => {
                getStateCodeOptions.reject(error);
            });
    }
    proceedCheckout():any {
        let _self = this;
        let requestData = {
            conversionRate: 0,
            totalAmountPayable: 0,
            totalAmount:0,
            totalDiscount:0,
            totalTax:0,
            otherFees:0,
            serviceType: 0,
            productId: 0,
            productDesc: 0,
            quantity: 0,
            subTotal:0,
            total:0,
            price:0,
            taxId: "null",
            taxType: "null",
            taxAmount:0,
            taxRate:"null",
            discountId:"null",
            coupoubCode:"null",
            discountRate:"null",
            discountType:"null",
            discountAmount:0,
            recipientId: "null",
            erp_points: "null",
            partnerOwnerCode: "null",
            productName: "",
            onlinePurchaseType: "EXTEND_AWARDS",
            payer_name: "null",
            payer_tin: "null",
            payer_email: "null",
            payer_phoneNo: "null",
            payer_nationality: "null",
            payer_addressLine: "null",
            payer_city: "null",
            payer_state: "null",
            payer_country: "null",
            payer_postalCode: "null",
            payer_nric: "null",
            payer_ssm: "null",
            payer_passport: "null",
            payer_invoice: "null",
            payer_type: "null"

        }
        $('#payment-proceed').click(function() {
            let isValid = true;
            const invoice_name = $('#invoice_issuarce_name_extend').val();
            const invoice_email = $('#invoice_issuarce_email_extend').val();
            const invoice_passport = $('#invoice_issuarce_passport_extend').val();
            const invoice_citizenship = $('input[name="citizenship"]:checked').val();
            const invoice_nric = $('#invoice_issuarce_NRIC_extend').val();
            const invoice_ssm = $('#invoice_issuarce_SSM_extend').val();
            const invoice_tin = $('#invoice_issuarce_tin_extend').val();
            const invoice_mobile = $('#invoice_issuarce_number_extend').val();
            const invoice_address = $('#invoice_issuarce_address_extend').val();
            const invoice_country = $('#issuanceCountry_extend').val();
            const invoice_city = $('#invoice_issuarce_city_extend').val();
            const invoice_state = $('#issuanceState_extend').val();
            const invoice_postalCode = $('#invoice_issuarce_postCode_extend').val();
            const invoice_type = $("input[name='invoice-flag']:checked").val();
            const invoice_payer_type = $('input[name="Payer-Type"]:checked').val();
            $('.error').remove();
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            // Validate name
            if (invoice_name === '') {
                $('#invoice_issuarce_name_extend').after('<span class="error">Name is required</span>');
                isValid = false;
            }
            // Validate email
            if (invoice_email === '') {
                $('#invoice_issuarce_email_extend').after('<span class="error">Email is required</span>');
                isValid = false;
            } else if (!emailPattern.test(invoice_email)) {
                $('#invoice_issuarce_email_extend').after('<span class="error">Invalid email format</span>');
                isValid = false;
            }
            //validate Mobile No
            const mobilePattern = /^\d{7,15}$/;
            if (invoice_mobile === '') {
                $('#invoice_issuarce_number_extend').after('<span class="error">mobile is required</span>');
                isValid = false;
            } else if (!mobilePattern.test(invoice_mobile)) {
                $('#invoice_issuarce_number_extend').after('<span class="error">Invalid mobile format</span>');
                isValid = false;
            }
             // Validate adress
             if (invoice_address === '') {
                $('#invoice_issuarce_address_extend').after('<span class="error">Address is required</span>');
                isValid = false;
            } 
             // Validate Country
             if (invoice_country === null) {
                $('#issuanceCountry_extend').after('<span class="error">Country is required</span>');
                isValid = false;
            } 
              // Validate State
              if (invoice_state === null) {
                $('#issuanceState_extend').after('<span class="error">State is required</span>');
                isValid = false;
            } 
            // Validate City
            if (invoice_city === '') {
                $('#invoice_issuarce_city_extend').after('<span class="error">City is required</span>');
                isValid = false;
            } 
             // Validate Postal Code
             if (invoice_postalCode === '') {
                $('#invoice_issuarce_postCode_extend').after('<span class="error">Postcode is required</span>');
                isValid = false;
            }
            //Validate NRIC or Passport number based on citizenship
            let selectedPayer = $('input[name="Payer-Type"]:checked').val();
            if (selectedPayer === 'single') {
                if (invoice_citizenship === 'my') {
                    if (invoice_nric === '') {
                        $('#invoice_issuarce_NRIC_extend').after('<span class="error">NRIC is required for Malaysian citizens</span>');
                        isValid = false;
                    } else if (!/^\d{6}-\d{2}-\d{4}$/.test(invoice_nric)) {
                        $('#invoice_issuarce_NRIC_extend').after('<span class="error">Invalid NRIC format (e.g., 123456-78-1234)</span>');
                        isValid = false;
                    }
                } else {
                    if (invoice_passport === '') {
                        $('#invoice_issuarce_passport_extend').after('<span class="error">Passport number is required for non-Malaysian citizens</span>');
                        isValid = false;
                    } else if (/[^A-Z0-9]+/g.test(invoice_passport)) {
                        $('#invoice_issuarce_passport_extend').after('<span class="error">Invalid passport number format</span>');
                        isValid = false;
                    }
                }
            }
             // Validate SSM
             if (selectedPayer !== 'single') {
                if (invoice_ssm === '') {
                    $('#invoice_issuarce_SSM_extend').after('<span class="error">SSM is required</span>');
                    isValid = false;
                } else if (!/^[a-zA-Z0-9]+$/.test(invoice_ssm)){
                    $('#invoice_issuarce_SSM_extend').after('<span class="error">Invalid SSM number format</span>');
                    isValid = false;
                }
            }
            // Validate tin
            const tinPattern = /^[a-zA-Z0-9]+$/;
            if (invoice_tin === '') {
                $('.tooltip-icon').after('<span class="error">TIN is required</span>');
                isValid = false;
            } else if (!tinPattern.test(invoice_tin)) {
                $('.tooltip-icon').after('<span class="error">Invalid TIN format</span>');
                isValid = false;
            }
            //Checkbox Validation
            let invoiceCheckbox = $("#check-group_extend");
            let invoiceCheckedVal = $("input[name='invoice-flag']:checked").val();
            if(invoiceCheckedVal === 'invoice-true'){
                if ($('#invoice-checkbox-extend').is(':checked')) {
                    isValid = true;
                } else {
                    $(invoiceCheckbox).after('<span class="error checkbox_invoice">Checkbox is required</span>');
                    isValid = false;
                }
            }
            // if (!isValid) {
            //     event.preventDefault(); // Prevent form submission if validation fails
            // }
            var extendval = $("#online-services-extend-desktop").val();
            // input box validation
            if( extendval == 0 ||  $('#online-service-check').find(".online-services--checkbox input").prop('checked')== false ) {
                $('#payment-proceed').css({ 'opacity': '0.5','pointer-events': 'none','background-color':'#808080' });
                
            } else {
                $('#payment-proceed').css({ 'opacity': '1.0','pointer-events': 'auto','background-color':'#005aaa' });
                requestData.totalAmountPayable = $("#my-order-points-extend-total").text();
                requestData.totalAmount = $("#my-order-points-extend-total").text();
                requestData.subTotal =  $("#my-order-points-extend-total").text();
                requestData.total =  $("#my-order-points-extend-total").text();
                requestData.serviceType = _self.enrichExtendData.serviceType;
                requestData.productId = _self.enrichExtendData.code;
                requestData.quantity = _self.enrichExtendData.minimumAmount;
                requestData.conversionRate = _self.enrichExtendData.monetaryAmount;
                requestData.price = _self.enrichExtendData.monetaryAmount;
                requestData.productDesc = _self.enrichExtendData.description;
                requestData.partnerOwnerCode = _self.enrichExtendData.partnerOwnerCode;
                requestData.erp_points = extendval;
                requestData.productName = _self.enrichExtendData.productName;
                requestData.payer_name = invoice_name;
                requestData.payer_tin = invoice_tin;
                requestData.payer_email = invoice_email;
                requestData.payer_phoneNo = invoice_mobile;
                requestData.payer_nationality = invoice_citizenship;
                requestData.payer_addressLine = invoice_address;
                requestData.payer_city = invoice_city;
                requestData.payer_state = invoice_state;
                requestData.payer_country = invoice_country;
                requestData.payer_postalCode = invoice_postalCode;
                requestData.payer_nric = invoice_nric;
                requestData.payer_ssm = invoice_ssm;
                requestData.payer_passport = invoice_passport;
                requestData.payer_invoice = invoice_type;
                requestData.payer_type = invoice_payer_type;
                adobeDataLayer.push('click', {
                    'pageName': '',
                    'pageType': 'Enrich - Point Services - Extend Your Enrich Points',
                    'clickName': 'click:btn-click:point-services-extend-points-payment',
                    'componentType': 'btn',
                    'componentName': 'Payment Button',
                    'componentID': '',
                    'attributes': [
                        {
                            'key': 'point-services-extend-points-submit',
                            'value': requestData.erp_points +':'+requestData.conversionRate+':myr'+requestData.totalAmount
                        }
                    ]
                });
                const errorLength = $(".error").length;
                let selectedInvocieFlag = $('input[name="invoice-flag"]:checked').val();
                if (selectedInvocieFlag === 'invoice-true') {
                if (errorLength === 0) {
                _self.bookingformcommon.preloader();
                $.ajax({
                    type: 'POST',
                    url: "/bin/services/new/paymentcheckoutFormGetPPID",
                    data: requestData,
                    success: function(data:any) {
                        _self.bookingformcommon.preloaderClose();
                        let json: any = null;
                        if(typeof data==='string') {
                            json = JSON.parse(data);
                        } else {
                            json = data;
                        }
                        if(json.errorCode === "OK" && json.id !== undefined){
                        const localData = {
                            postRedirection: window.location.href,
                            postRedirectionValue: $("#my-order-points-extend-total").text()
                        }
                        let setItems = function() {
                            localStorage.setItem('online-services-data', JSON.stringify(localData));
                            if(localStorage.getItem('online-services-data') === null) {
                                setItems();
                            } else {
                                let url = window.location.href.split('/');
                                window.location.href = "https://" + window.location.hostname + "/" +url[3]+ "/" + url[4] + "/enrich-portal/home/online-services/checkout.html?ppid="+ json.id;
                            }
                        }
                        setItems();
                    } else {
                        if(json.errorMsg) {
                            $('.payment-error').addClass('showclass');
                            $('.payment-error').removeClass('hideclass');
                            $('.payment-error').html(json.errorMsg);
                        } else {
                        $('.payment-error').addClass('showclass');
                        $('.payment-error').removeClass('hideclass');
                        //$('.payment-error').html('Unable to proceed, please try again.');
                    }
                        }
                    }, error: function(error:any) {
                        _self.bookingformcommon.preloaderClose();
                        console.log(error);
                        $('.payment-error').addClass('showclass');
                        $('.payment-error').removeClass('hideclass');
                        //$('.payment-error').html = "Something went wrong. Please try again.";
                    }
                });
            } else {
                $('html, body').animate({
                    scrollTop: $('#popup-invoice-issuarce-form-anchor-extend').offset().top
                }, 1000);
        }
        } else {
            _self.bookingformcommon.preloader();
            $.ajax({
                type: 'POST',
                url: "/bin/services/new/paymentcheckoutFormGetPPID",
                data: requestData,
                success: function (data: any) {
                    _self.bookingformcommon.preloaderClose();
                    let json: any = null;
                    if (typeof data === 'string') {
                        json = JSON.parse(data);
                    } else {
                        json = data;
                    }
                    if (json.errorCode === "OK" && json.id !== undefined) {
                        const localData = {
                            postRedirection: window.location.href,
                            postRedirectionValue: $("#my-order-points-buy-total").text(),
                        }
                        let setItems = function () {
                            localStorage.setItem('online-services-data', JSON.stringify(localData));
                            if (localStorage.getItem('online-services-data') === null) {
                                setItems();
                            } else {
                                let url = window.location.href.split('/');
                                window.location.href = "https://" + window.location.hostname + "/" + url[3] + "/" + url[4] + "/enrich-portal/home/online-services/checkout.html?ppid=" + json.id;
                            }
                        }
                        setItems();
                    } else {
                        if (json.errorMsg) {
                            $('.payment-error').addClass('showclass');
                            $('.payment-error').removeClass('hideclass');
                            $('.payment-error').html(json.errorMsg);
                        } else {
                            $('.payment-error').addClass('showclass');
                            $('.payment-error').removeClass('hideclass');
                            //$('.payment-error').html('Unable to proceed, please try again.');
                        }
                    }

                }, error: function (error: any) {
                    _self.bookingformcommon.preloaderClose();
                    console.log(error);
                    $('.payment-error').addClass('showclass');
                    $('.payment-error').removeClass('hideclass');
                    //$('.payment-error').html = "Something went wrong. Please try again.";
                }
            });
        }
            }
        });
    }
}    
let scope : Element = document.querySelector('.onlineServiceExtendpoints');
if(scope){
    try{
        let extendPointsForm = new onlineServicesExtend();
        extendPointsForm.initTextInputs();     
        extendPointsForm.enrichExtendPointsCheck();
        extendPointsForm.ValidationForm();
        extendPointsForm.invoiceIssuancePopup();
        extendPointsForm.selectCountryData();
        extendPointsForm.invoicePopupCheckbox();
        extendPointsForm.proceedCheckout();
        var adobeDataLayer = new adobeDataLayerWrapper();
        adobeDataLayer.push('pageLoaded', {
            'pageName': '',
            'pageType': 'Enrich - Point Services - Extend Your Enrich Points',
            'attributes': []
        });
        }catch(e){console.error(e);}
}